import { ObjectSchema } from 'yup';

import { yup } from '~/adapters/YupAdapter';
import { SurveyAnswerModel } from '~modules/surveys/models/SurveyAnswerModel';
import { SurveyExtraQuestionModel } from '~modules/surveys/models/SurveyExtraQuestionModel';
import { SurveyQuestionModel } from '~modules/surveys/models/SurveyQuestionModel';
import { SurveyAnswerTypeIdEnum } from '~modules/surveys/types/SurveyAnswerTypeIdEnum';

export function getSurveyFormValidationSchema(): ObjectSchema<any> {
  const validateQuestion = (question: SurveyQuestionModel | SurveyExtraQuestionModel) => {
    let schema = yup.object().shape({});

    switch (question.answerTypeId) {
      case SurveyAnswerTypeIdEnum.RADIO_GROUP:
        schema = yup.object({
          answerId: yup.number().nullable().required(),
          textValue: yup.string().when('answers', {
            is: (answers: SurveyAnswerModel[]) =>
              !!answers?.find((a) => a.answerId === question.answerId && a.isTextAnswer),
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.notRequired(),
          }),
        });
        break;

      case SurveyAnswerTypeIdEnum.CHECKBOX_GROUP:
        schema = yup.object({
          answers: yup
            .array()
            .of(
              yup.object({
                isChecked: yup.boolean(),
                isTextAnswer: yup.boolean(),
                textValue: yup.string().when(['isChecked', 'isTextAnswer'], {
                  is: (isChecked: boolean, isTextAnswer: boolean) => isChecked && isTextAnswer,
                  then: (s) => s.required(),
                  otherwise: (s) => s.notRequired(),
                }),
              }),
            )
            .test('at-least-one-checked', '', (_, context) => {
              return context.originalValue?.some((answer: SurveyAnswerModel) => answer.isChecked);
            }),
        });
        break;

      case SurveyAnswerTypeIdEnum.TEXT_SHORT:
      case SurveyAnswerTypeIdEnum.TEXT_LONG:
        schema = yup.object({
          textValue: yup.string().required(),
        });
        break;

      case SurveyAnswerTypeIdEnum.HAPPY_INDEX_5:
      case SurveyAnswerTypeIdEnum.HAPPY_INDEX_10:
        schema = yup.object({
          happyIndex: yup.number().required(),
        });
        break;

      default:
        schema = yup.object();
    }

    schema = schema.shape({
      extraQuestions: yup.array().of(
        yup.lazy((extra: SurveyExtraQuestionModel) => {
          const shouldValidate =
            question.happyIndex !== null &&
            extra.happyIndexMin !== null &&
            extra.happyIndexMax !== null &&
            question.happyIndex >= extra.happyIndexMin &&
            question.happyIndex <= extra.happyIndexMax;

          return shouldValidate ? validateQuestion(extra) : yup.object();
        }),
      ),
    });

    return schema;
  };

  return yup.object({
    questions: yup.array().of(yup.lazy(validateQuestion)).required(),
  });
}
